<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="sessions-dropdown">
    <label for="sessions-select">Select a session to view:</label>
    <select
      class="sessions-select"
      id="sessions-select"
      v-model="selectedSession"      @change="handleSessionClick"
    >
      <option
        v-for="session in sessions"
        v-bind:key="session.id"
        v-bind:value="session"
      >
        {{ session.index}} - {{ session.id }} -
        {{ session.date.toLocaleDateString("en-US", dateOptions) }},
        {{ session.movements[0] ? session.movements[0].name : "" }}
      </option>
    </select>
  </div>
</template>

<script>
import { ref } from 'vue'
export default {
  name: 'SessionsDropDown',
  props: ['sessions', 'allowMultiple', 'userId'],
  data () {
    return {
      dateOptions: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }
    }
  },
  setup (props, { emit }) {
    const selectedSession = ref(null)
    const handleSessionClick = (event) => {
      emit('sessionClicked', selectedSession.value)
    }

    return {
      handleSessionClick,
      selectedSession
    }
  }
}
</script>

<style>
.sessions-dropdown {
  display: flex;
  flex-direction: column;
  width: 95%;
  margin: 20px 10px;
}
.sessions-select {
  padding: 10px;
  border: none;
  background: #ceebee;
  border-radius: 10px;
}
</style>
